import {createBrowserHistory as createHistory} from 'history';

export const history = createHistory();